const API_PREFIX = process.env.VUE_APP_BASE_API || ''

/** 为后端返回的相对路径资源（图片等）拼接 API 前缀，如 /prod-api/profile/... */
export function resolveAssetUrl(url) {
  if (!url || !String(url).trim()) return ''
  let u = String(url).trim()
  if (/^https?:\/\//i.test(u)) return u
  if (!u.startsWith('/')) u = '/' + u
  if (API_PREFIX && (u === API_PREFIX || u.startsWith(API_PREFIX + '/'))) return u
  return API_PREFIX + u
}

/** 富文本 HTML 内 img src 同样补全 API 前缀 */
export function resolveHtmlAssetUrls(html) {
  if (!html || !String(html).trim()) return ''
  return String(html).replace(
    /(<img\b[^>]*\ssrc\s*=\s*["'])([^"']+)(["'][^>]*>)/gi,
    (match, before, src, after) => before + resolveAssetUrl(src) + after
  )
}
